import * as t from 'io-ts'
import * as tv from '@espoon-voltti/ts-libs/lib/io-ts-types'

const GeneralGrantPeriodType = t.literal('YOUTH_GENERAL_GRANT')
const YouthGrantPeriodType = t.literal('YOUTH_PROJECT_GRANT')

export const GrantPeriodType = t.union([
  GeneralGrantPeriodType,
  YouthGrantPeriodType
])
export type GrantPeriodType = t.TypeOf<typeof GrantPeriodType>

export const GrantPeriod = t.type({
  id: t.string,
  type: GrantPeriodType,
  startDatetime: tv.dateTimeFromString,
  endDatetime: tv.dateTimeFromString,
  name: t.string,
  state: t.keyof({
    ACTIVE: null,
    PAYMENT: null,
    FINAL: null
  }),
  diaryNumber: t.string
})
export type GrantPeriod = t.TypeOf<typeof GrantPeriod>
